import Vue from 'vue';
import gaService from './ga.service';

export default {
  async openSession(gameId, language, isMobile, backUrl) {
    gaService.send('games', 'flg', gameId);
    return (await Vue.http.post('/api/flg/session/open', { gameId, language, isMobile, backUrl })).data;
  },
  async openDemoSession(gameId, language, isMobile, backUrl) {
    gaService.send('games-demo', 'flg', gameId);
    return (await Vue.http.post('/api/flg/session/opendemo', { gameId, language, isMobile, backUrl })).data;
  },
  async closeSession() {
    return (await Vue.http.post('/api/flg/session/close')).data;
  }
}



// WEBPACK FOOTER //
// ./_common/services/flg.service.js